<template>
  <div>
    <div class="page_title flex_between">
      <span>申请认证</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div class="box">
      <div class="container">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <div class="title item">个人信息</div>
          <el-form-item label="姓名" prop="doctor_name">
            <el-input
              v-model="ruleForm.doctor_name"
              class="myinput"
              maxlength="18"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="身份证号" prop="id_card">
            <el-input
              v-model="ruleForm.id_card"
              class="myinput"
              maxlength="18"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>

          <el-form-item label="所在地区" prop="district_id">
            <div class="areabox">
              <el-select
                v-model="province"
                placeholder="请选择省"
                class="filter-item"
                @change="changeProvince"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.name"
                  :value="index"
                />
              </el-select>

              <el-select
                v-model="city"
                placeholder="请选择市"
                class="filter-item selectbox"
                @change="changeCity"
              >
                <el-option
                  v-for="(item, index) in queryCityList"
                  :key="index"
                  :label="item.name"
                  :value="index"
                />
              </el-select>

              <el-select
                v-model="district"
                placeholder="请选择区"
                class="filter-item"
                @change="changeDistrict"
              >
                <el-option
                  v-for="(item, index) in queryRegionList"
                  :key="index"
                  :label="item.name"
                  :value="index"
                />
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="医院名称" prop="hospital">
            <el-input
              v-model="ruleForm.hospital"
              class="myinput"
              maxlength="20"
              placeholder="请填写目前执业的医院"
            ></el-input>
          </el-form-item>

          <el-form-item label="擅长方向" id="begoodatitem">
            <div>
              <div
                class="selectgoodlist"
                id="begoodat"
                @click="showgoodlist = true"
              >
                <el-tag
                  :key="index"
                  v-for="(tag, index) in goodTags"
                  type="info"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                  >{{ tag.be_good_at_name }}</el-tag
                >
              </div>

              <div class="goodlist" v-if="showgoodlist">
                <div class="search">
                  <el-input
                    placeholder="请输入内容"
                    v-model="goodlistKeyword"
                    class="input-with-select"
                    clearable
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getGoodList"
                    ></el-button>
                  </el-input>
                </div>

                <template v-if="goodList.length">
                  <div
                    class="item"
                    v-for="(item, index) in goodList"
                    :key="index"
                  >
                    <div class="itemtitle">{{ item.department_name }}</div>
                    <div class="gooditembox">
                      <div
                        v-for="(i, ind) in item.list"
                        :key="ind"
                        :class="i.isCheck ? 'checkitem' : 'gooditem'"
                        @click="checkItem(i)"
                      >
                        {{ i.be_good_at_name }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    style="
                      height: 220px;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    暂无数据
                  </div>
                </template>

                <div class="closegood" @click="closegoodlist">关闭</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="专业" prop="major_name">
            <el-input
              v-model="ruleForm.major_name"
              class="myinput"
              maxlength="10"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="执业证书编号" prop="qualification_num">
            <el-input
              v-model="ruleForm.qualification_num"
              class="myinput"
              maxlength="30"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="科室" prop="department_id">
            <el-select
              v-model="ruleForm.department_id"
              placeholder="请选择科室"
              class="myinput"
            >
              <el-option
                v-for="(item, index) in departmentList"
                :key="index"
                :label="item.department_name"
                :value="item.department_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="职称" prop="title">
            <el-select
              v-model="ruleForm.title"
              placeholder="请选择职称"
              class="myinput"
            >
              <el-option
                v-for="(item, index) in [
                  '主任医师',
                  '副主任医师',
                  '主治医师',
                  '住院医师',
                ]"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="个人简介" prop="introduction">
            <el-input
              type="textarea"
              v-model="ruleForm.introduction"
              maxlength="500"
              show-word-limit
              class="myinput"
              :autosize="{ minRows: 5, maxRows: 7 }"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="title" style="margin: 140px 0 20px">资料上传</div>
        <!-- 头像上传 -->
        <div>
          <span style="color: #e1342f">*</span>
          <span class="gray">医生头像</span>
        </div>
        <div class="headimg">
          <el-upload
            class="avatar-uploader"
            name="image"
            accept=".png,.jpeg,.jpg"
            :action="uploadUrl"
            :data="uploadExtraData"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="
              (res, file, fileList) => {
                return handleAvatarSuccess(res, file, fileList, 'head_img');
              }
            "
            :before-upload="
              (file) => {
                return beforeAvatarUpload(file, 1);
              }
            "
          >
            <img v-if="head_img" :src="head_img" class="avatar" />
            <div v-else>
              <i class="el-icon-plus uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div class="zigeimgbox">
          <!-- 医师执业证书 -->
          <div>
            <div class="gray">
              <span style="color: #e1342f">*</span>
              <span class="gray">医师执业证书</span>
            </div>
            <div class="zhiyebox">
              <div class="zigeimg" style="margin-right: 20px">
                <div class="backimg">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    accept=".png,.jpeg,.jpg"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="
                      (res, file, fileList) => {
                        return handleAvatarSuccess(
                          res,
                          file,
                          fileList,
                          'zhiye_img1'
                        );
                      }
                    "
                    :before-upload="
                      (file) => {
                        return beforeAvatarUpload(file, 2);
                      }
                    "
                  >
                    <img v-if="zhiye_img1" :src="zhiye_img1" class="avatar" />
                    <div v-else>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="uploader-icon"
                        size="medium"
                        >添加</el-button
                      >
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="zigeimg">
                <div class="backimg">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    accept=".png,.jpeg,.jpg"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="
                      (res, file, fileList) => {
                        return handleAvatarSuccess(
                          res,
                          file,
                          fileList,
                          'zhiye_img2'
                        );
                      }
                    "
                    :before-upload="
                      (file) => {
                        return beforeAvatarUpload(file, 2);
                      }
                    "
                  >
                    <img v-if="zhiye_img2" :src="zhiye_img2" class="avatar" />
                    <div v-else>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="uploader-icon"
                        size="medium"
                        >添加</el-button
                      >
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <!-- 医生职称证书 -->
          <div style="margin: 0 40px">
            <div class="gray">
              <!-- <span style="color: #e1342f">*</span> -->
              <span class="gray">医生职称证书</span>
            </div>
            <div class="zhiyebox">
              <div class="zigeimg" style="margin-right: 20px">
                <div class="backimg">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    accept=".png,.jpeg,.jpg"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="
                      (res, file, fileList) => {
                        return handleAvatarSuccess(
                          res,
                          file,
                          fileList,
                          'zige_img1'
                        );
                      }
                    "
                    :before-upload="
                      (file) => {
                        return beforeAvatarUpload(file, 2);
                      }
                    "
                  >
                    <img v-if="zige_img1" :src="zige_img1" class="avatar" />
                    <div v-else>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="uploader-icon"
                        size="medium"
                        >添加</el-button
                      >
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="zigeimg">
                <div class="backimg">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    accept=".png,.jpeg,.jpg"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="
                      (res, file, fileList) => {
                        return handleAvatarSuccess(
                          res,
                          file,
                          fileList,
                          'zige_img2'
                        );
                      }
                    "
                    :before-upload="
                      (file) => {
                        return beforeAvatarUpload(file, 2);
                      }
                    "
                  >
                    <img v-if="zige_img2" :src="zige_img2" class="avatar" />
                    <div v-else>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="uploader-icon"
                        size="medium"
                        >添加</el-button
                      >
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <!--专业技术资格证书  -->
          <div>
            <div class="gray">专业技术资格证书</div>
            <div class="zigeimg" style="margin-top: 10px">
              <div class="backimg">
                <el-upload
                  class="avatar-uploader"
                  name="image"
                  accept=".png,.jpeg,.jpg"
                  :action="uploadUrl"
                  :data="uploadExtraData"
                  :headers="uploadHeaders"
                  :show-file-list="false"
                  :on-success="
                    (res, file, fileList) => {
                      return handleAvatarSuccess(
                        res,
                        file,
                        fileList,
                        'qualification_certificate'
                      );
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeAvatarUpload(file, 2);
                    }
                  "
                >
                  <img
                    v-if="qualification_certificate"
                    :src="qualification_certificate"
                    class="avatar"
                  />
                  <div v-else>
                    <el-button
                      type="primary"
                      icon="el-icon-plus"
                      class="uploader-icon"
                      size="medium"
                      >添加</el-button
                    >
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px">
          <div class="tip" v-if="$route.query.is_save">
            保存时，个人信息中相关字段不支持修改
          </div>
          <el-button
            v-if="$route.query.is_save == 1"
            type="primary"
            plain
            style="width: 92px; margin-right: 20px"
            size="medium"
            @click="save"
            >保存</el-button
          >
          <el-button
            type="primary"
            style="width: 92px"
            size="medium"
            @click="submit('ruleForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import doctor from "../../../api/doctor";
import constant from "../../../service/common/constant";
import axios from "../../../service/axios/axios";
import _ from "lodash";
export default {
  data() {
    let checkId = (rule, value, callback) => {
      if (value != "") {
        if (value.length != 15 && value.length != 18) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      provinceList: [],
      queryCityList: [],
      queryRegionList: [],
      province: "",
      city: "",
      district: "",
      goodList: [],
      showgoodlist: false,
      goodlistKeyword: "",
      goodTags: [],
      departmentList: [],
      ruleForm: {
        doctor_id: this.$route.query.doctor_id,
        doctor_name: this.$route.query.doctor_name,
        head_img: "",
        sex: this.$route.query.sex == "男" ? 1 : 2,
        title: "",
        hospital: "",
        id_card: "",
        province_id: "",
        city_id: "",
        district_id: "",
        be_good_at: "",
        department_id: "",
        major_name: "",
        qualification_num: "",
        introduction: "",
        //执业证书
        practice_certificate: "",
        // 资格证书
        qualification: "",
        zhiye_img1: "",
        zhiye_img2: "",
        zige_img1: "",
        zige_img2: "",
        // 专业资格证书
        qualification_certificate: "",
        submit_type: "",
      },
      rules: {
        id_card: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          {
            min: 15,
            max: 18,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
          {
            validator: checkId,
            trigger: "blur",
          },
        ],
        district_id: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "blur",
          },
        ],
        hospital: [
          { required: true, message: "请填写目前执业的医院", trigger: "blur" },
        ],
        major_name: [{ required: true, message: "请输入", trigger: "blur" }],
        department_id: [
          { required: true, message: "请选择科室", trigger: "blur" },
        ],
        title: [{ required: true, message: "请选择职称", trigger: "blur" }],
        doctor_name: [
          { required: true, message: "请输入医生名字", trigger: "blur" },
        ],
        introduction: [
          { required: true, message: "请填写个人简介", trigger: "blur" },
          { min: 10, max: 500, message: "至少输入10个字", trigger: "blur" },
        ],
      },
      uploadExtraData: {
        img_type: 1,
        suffix: ".jpg",
      },
      head_img: "",
      qualification_certificate: "",
      zhiye_img1: "",
      zhiye_img2: "",
      zige_img1: "",
      zige_img2: "",
    };
  },
  watch: {
    zhiye_img1(val) {
      this.ruleForm.practice_certificate =
        this.ruleForm.zhiye_img1 + "," + this.ruleForm.zhiye_img2;
    },
    zhiye_img2(val) {
      this.ruleForm.practice_certificate =
        this.ruleForm.zhiye_img1 + "," + this.ruleForm.zhiye_img2;
    },
    zige_img1(val) {
      this.ruleForm.qualification =
        this.ruleForm.zige_img1 + "," + this.ruleForm.zige_img2;
    },
    zige_img2(val) {
      this.ruleForm.qualification =
        this.ruleForm.zige_img1 + "," + this.ruleForm.zige_img2;
    },
    goodTags(val) {
      setTimeout(() => {
        let h = document.getElementById("begoodat").offsetHeight;
        document.getElementById("begoodatitem").style.marginBottom =
          h - 20 + "px";
      }, 50);
    },
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "api/platform/upload/uploadFile";
      } else {
        return "platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  created() {
    this.getProvince();
    this.getGoodList();
    this.getdepartmentList();
    this.getSaveInfo();
  },
  methods: {
    //获取省级数据
    getProvince() {
      platform.getProvinceCityDistrict().then((res) => {
        this.provinceList = res.data.list;
      });
    },
    //改变省级数据
    changeProvince(index) {
      this.ruleForm.province_id = this.provinceList[index].province_id;
      this.queryCityList = this.provinceList[index].city;
      this.ruleForm.city_id = this.queryCityList[0].city_id;
      this.city = 0;
      this.queryRegionList = this.queryCityList[0].district;
      this.ruleForm.district_id = this.queryRegionList[0].district_id;
      this.district = 0;
    },
    //改变市级数据
    changeCity(index) {
      this.queryRegionList = this.queryCityList[index].district;
      this.ruleForm.city_id = this.queryCityList[index].city_id;
      this.ruleForm.district_id = this.queryRegionList[0].district_id;
      this.district = 0;
    },
    //改变区级数据
    changeDistrict(index) {
      this.ruleForm.district_id = this.queryRegionList[index].district_id;
    },
    //获取医生擅长列表
    getGoodList() {
      doctor
        .getDoctorBeGoodsAt({ be_good_at_name: this.goodlistKeyword })
        .then((res) => {
          if (JSON.stringify(res.data.list) == "{}") {
            this.goodList = [];
            return;
          }
          this.goodList = res.data.list.map((item) => {
            item.list.map((i) => {
              i.isCheck = false;
              return i;
            });
            return item;
          });

          let check_id = this.goodTags.map((item) => {
            return item.be_good_at_id;
          });
          this.goodList.forEach((item) => {
            item.list.forEach((i) => {
              i.isCheck = false;
              if (check_id.includes(i.be_good_at_id)) {
                i.isCheck = true;
              }
            });
          });
        });
    },
    //获取科室列表
    getdepartmentList() {
      doctor.getDepartmentList().then((res) => {
        this.departmentList = res.data.list;
      });
    },
    //选择擅长列表里面的
    checkItem(i) {
      if (this.goodTags.length >= 40) {
        this.$message.error("最多选择40项擅长项");
        return;
      }
      i.isCheck = !i.isCheck;
      if (i.isCheck) {
        this.goodTags.push(i);
        setTimeout(() => {
          let h = document.getElementById("begoodat").offsetHeight;
          document.getElementById("begoodatitem").style.marginBottom =
            h - 20 + "px";
        }, 50);
      } else {
        this.goodTags.splice(this.goodTags.indexOf(i), 1);
        setTimeout(() => {
          let h = document.getElementById("begoodat").offsetHeight;
          document.getElementById("begoodatitem").style.marginBottom =
            h - 20 + "px";
        }, 400);
      }
    },
    //删除单个标签
    handleClose(tag) {
      this.goodTags.splice(this.goodTags.indexOf(tag), 1);
      setTimeout(() => {
        let h = document.getElementById("begoodat").offsetHeight;
        document.getElementById("begoodatitem").style.marginBottom =
          h - 30 + "px";
      }, 400);
      let check_id = this.goodTags.map((item) => {
        return item.be_good_at_id;
      });
      this.goodList.forEach((item) => {
        item.list.forEach((i) => {
          i.isCheck = false;
          if (check_id.includes(i.be_good_at_id)) {
            i.isCheck = true;
          }
        });
      });
    },
    //关闭擅长列表
    closegoodlist() {
      setTimeout(() => {
        this.showgoodlist = false;
      }, 100);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList, imgname) {
      if (res.code === 0) {
        //半路径
        this.ruleForm[imgname] = res.data.pic;
        if (imgname == "head_img") {
          this.head_img = res.data.path;
        } else {
          axios({
            method: "get",
            url: res.data.path,
          }).then((res) => {
            //绝对路径
            this[imgname] = res;
          });
        }
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file, type) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = type;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value },
        })
        .then((res) => {
          this[imgname] = res;
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    //提交
    submit(formName) {
      if (this.goodTags.length > 40) {
        this.$message.error("最多选择40项擅长项");
        return false;
      }
      if (
        !this.ruleForm.head_img ||
        !this.ruleForm.zhiye_img1 ||
        !this.ruleForm.zhiye_img2
        // ||
        // !this.ruleForm.zige_img1 ||
        // !this.ruleForm.zige_img2
      ) {
        this.$message.error("请上传必须的图片");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = _.omit(this.ruleForm, [
            "zhiye_img1",
            "zhiye_img2",
            "zige_img1",
            "zige_img2",
          ]);
          data.submit_type = 2;
          let be_good_at_arr = this.goodTags.map((item) => {
            return item.be_good_at_id;
          });
          data.be_good_at = be_good_at_arr.toString();
          doctor
            .saveAuthentication(data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("已提交");
                this.back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //保存
    save() {
      let data = _.omit(this.ruleForm, [
        "zhiye_img1",
        "zhiye_img2",
        "zige_img1",
        "zige_img2",
      ]);
      data.submit_type = 1;
      let be_good_at_arr = this.goodTags.map((item) => {
        return item.be_good_at_id;
      });
      data.be_good_at = be_good_at_arr.toString();
      doctor
        .saveAuthentication(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("已保存");
            this.back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取保存的草稿
    getSaveInfo() {
      let reviewed_id = this.$route.query.reviewed_id;
      if (reviewed_id == "0") {
        return false;
      }
      doctor
        .licenseDoctorItem({ reviewed_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.ruleForm = _.pick(info, [
              "doctor_name",
              "sex",
              "head_img",
              "title",
              "hospital",
              "introduction",
              "id_card",
              "department_id",
              "province_id",
              "city_id",
              "district_id",
              "major_name",
              "qualification_num"
            ]);
            this.ruleForm = Object.assign(this.ruleForm, {
              doctor_id: this.$route.query.doctor_id,
              be_good_at: "",
              doctor_name: info.doctor_name_str,
              practice_certificate: "",
              qualification: "",
              zhiye_img1:
                info.practice_certificate.length && info.practice_certificate[0]
                  ? info.practice_certificate[0].pic
                  : "",
              zhiye_img2:
                info.practice_certificate.length && info.practice_certificate[1]
                  ? info.practice_certificate[1].pic
                  : "",
              zige_img1:
                info.qualification.length && info.qualification[0]
                  ? info.qualification[0].pic
                  : "",
              zige_img2:
                info.qualification.length && info.qualification[1]
                  ? info.qualification[1]
                  : "",
              qualification_certificate: info.qualification_certificate.length
                ? info.qualification_certificate[0].pic
                : "",
            });
            this.head_img = info.head_img_str;
            this.province = info.province_name;
            this.city = info.city_name;
            this.district = info.district_name;
            this.goodTags = info.be_good_at;
            if (info.qualification_certificate.length) {
              this.requestImg(
                info.qualification_certificate[0].path,
                "qualification_certificate"
              );
            }
            if (info.practice_certificate.length) {
              info.practice_certificate.length && info.practice_certificate[0]
                ? this.requestImg(
                    info.practice_certificate[0].path,
                    "zhiye_img1"
                  )
                : "";
              info.practice_certificate.length && info.practice_certificate[1]
                ? this.requestImg(
                    info.practice_certificate[1].path,
                    "zhiye_img2"
                  )
                : "";
              // this.requestImg(info.practice_certificate[0].path, 'zhiye_img1');
              // this.requestImg(info.practice_certificate[1].path, 'zhiye_img2');
            }
            if (info.qualification.length) {
              info.qualification.length && info.qualification[0]
                ? this.requestImg(info.qualification[0].path, "zige_img1")
                : "";

              info.qualification.length && info.qualification[1]
                ? this.requestImg(info.qualification[1].path, "zige_img2")
                : "";

              // this.requestImg(info.qualification[0].path, 'zige_img1');
              // this.requestImg(info.qualification[1].path, 'zige_img2');
            }
          }
          this.getGoodList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding: 20px;
}
.container {
  padding: 20px 0 20px 18px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-size: 16px;
  font-weight: 600;
  padding-left: 6px;
}
.gray {
  color: #747981;
}
.item {
  margin-bottom: 20px;
}
.myinput {
  width: 400px;
}
.areabox {
  display: flex;
  .filter-item {
    width: 128px;
  }
  .selectbox {
    margin: 0 8px;
  }
}
.selectgoodlist {
  width: 400px;
  min-height: 40px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
  &:hover {
    border: 1px solid #669961;
  }
}
.goodlist {
  background: #fff;
  box-sizing: border-box;
  width: 398px;
  height: 300px;
  overflow-y: scroll;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: solid 1px #c0c4cc;
  margin-top: 10px;
  z-index: 100000000;
  position: relative;
  .search {
    background-color: #fff;
    padding: 4px;
    position: sticky;
    top: 0;
  }
  .item {
    margin-bottom: 24px;
    padding: 0 5px 0 20px;
  }
  .closegood {
    height: 30px;
    line-height: 30px;
    width: 378px;
    background-color: #e6efeb;
    color: #699b64;
    text-align: center;
    cursor: pointer;
    position: sticky;
    bottom: 0px;
  }
}
.itemtitle {
  color: #191c21;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
}
.gooditembox {
  display: flex;
  flex-wrap: wrap;
  .gooditem {
    margin-right: 10px;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    margin-bottom: 6px;
    padding: 0 5px;
    box-sizing: border-box;
  }
}
.checkitem {
  background-color: #e6efeb;
  margin-right: 10px;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  color: #669961;
  margin-bottom: 6px;
  padding: 0 5px;
  box-sizing: border-box;
}

.headimg {
  width: 100px;
  height: 100px;
  margin: 10px 0 20px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .avatar {
    width: 100px;
    height: 100px;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
.zigeimg {
  width: 200px;
  height: 144px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border: solid 1px #d6d6d6;

  .backimg {
    width: 100%;
    height: 100%;
    background: url("../../../assets/img/login/back_img.jpg") center center
      no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .avatar {
    width: 178px;
    height: 124px;
  }
  .uploader-icon {
    color: #fff;
  }
}
.zigeimgbox {
  display: flex;
}
.zhiyebox {
  display: flex;
  margin-top: 10px;
}
.tip {
  color: red;
  margin-bottom: 10px;
}
.tip::before {
  content: "*";
}
</style>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.container .el-tag.el-tag--info {
  background-color: #fafafa;
  border-color: #e8e8e8;
  color: #191c21;
}
</style>
